<template lang="pug">
  v-form(ref="billingForm" id="billingForm" @submit.prevent="doCreateBilling" lazy-validation)
    v-container(grid-list-md)
      v-layout(wrap)
        v-flex(lg12 md12 xs12)
          v-radio-group(dense v-model="billing.useNpwp" row class="ml-2")
            v-radio(label="Dengan NPWP" :value="true" color="primary")
            v-radio(label="Tanpa NPWP" :value="false" color="primary")
        v-flex(lg6 md6 xs12)
          f-select-map(dense v-model="billing.mapTransaction" label="Kode Map" :rules="[v => !!v || 'Input kode map']" required v-on:map="map = $event" :mapData="mapData")
          f-select-pay-type(dense v-model="billing.jenisSetor" :mapId="billing.mapTransaction" label="Jenis Setor" :rules="[v => !!v || 'Input jenis setor']" required v-on:payType="payType = $event" :payTypeData="payTypeData")
          v-text-field(dense v-if="billing.useNpwp" v-model="billing.npwp" label="NPWP" maxlength="15" v-numeric-only :rules="[v => !!v || 'Input npwp']" required
          :append-outer-icon="!billing.useNpwp ? '' : 'mdi-magnify'" @keyup.enter="!billing.useNpwp ? '' : doInquiryNpwp()" @click:append-outer="doInquiryNpwp")
          v-text-field(dense v-else v-model="billing.kpp" label="KPP" maxlength="3" v-numeric-only :rules="[v => !!v || 'Input kode kpp']" required)
          v-text-field(dense v-model="billing.nama" label="Nama Wajib Pajak" :rules="[v => !!v || 'Input nama wajib pajak']" required :readonly="billing.useNpwp")
          v-text-field(dense v-model="billing.alamat" label="Alamat Wajib Pajak" :rules="[v => !!v || 'Input alamat wajib pajak']" required :readonly="billing.useNpwp")
          v-text-field(dense v-model="billing.kota" label="Kota Wajib Pajak" )
          v-text-field(dense v-model="billing.npwpRekanan" maxlength="16" label="NPWP Rekanan"  v-numeric-only  :rules="[v => (!requiredNpwpRekanan || !!v)  || 'Input npwp rekanan']" required)
          v-text-field(dense v-model="billing.nikRekanan" maxlength="16"  label="NIK Rekanan" v-numeric-only :rules="[v => (!requiredNikRekanan || !!v) || 'Input nik rekanan']" required)
        v-flex(lg6 md6 xs12)
          v-layout(wrap)
            v-flex(lg3 md3 xs12)
              f-select-month(dense v-model="billing.periode1" label="Masa Pajak Awal" :rules="[v => !!v || 'Input Masa Pajak Awal']" required)
            v-flex(lg3 md3 xs12)
              f-select-month(dense v-model="billing.periode2" label="Masa Pajak Akhir" :rules="[v => !!v || 'Input Masa Pajak Akhir']" required)
            v-flex(lg4 md4 xs12)
              v-text-field(dense v-model="billing.tahun" label="Tahun" :rules="[v => !!v || 'Input tahun']" required maxlength="4" v-numeric-only)
          v-text-field(dense v-model="billing.idWajibPajak" label="No. Identitas" :rules="[v => (!requiredIdPeserta || !!v) || 'Input id wajib pajak']" required maxlength="16" v-numeric-only)
          v-text-field(dense v-model="billing.noKetetapan" maxlength="15" v-numeric-only label="No Ketetapan" :rules="[v => (!requiredNoSK || !!v) || 'Input no ketetapan']" required)
          v-text-field(dense v-model="billing.nop" maxlength="18" v-numeric-only label="NOP" :rules="[v => (!requiredNop || !!v) || 'Input no ketetapan']" required) )
          v-text-field(dense v-model="billing.noFaktur" maxlength="16" v-numeric-only label="No Faktur" :rules="[v => (!requiredNoFaktur || !!v) || 'Input no faktur']" required)
          v-text-field(dense v-model="billing.npwpSetor" label="NPWP Penyetor" maxlength="15" v-numeric-only :rules="[v => !!v || 'Input NPWP Penyetor']" required)
          v-text-field(dense v-model="billing.namaSetor" label="Nama Penyetor" :rules="[v => !!v || 'Input Nama Penyetor']" required)
          f-decimalbox(v-model="billing.amount" label="Nominal" :rules="[v => !!v || 'Masukan nominal transaksi', v => (billing.amount || 0) > 0 || 'Nominal tidak valid' ]" required)
        v-flex(lg11 md12 xs12)
          v-text-field(dense v-model="uraian"  label="Uraian" readonly)
      div(justify-center style="text-align: center;" class="ma-2 menu-btn")
        v-btn(class="mx-1" @click="eventEmit('doBack')" v-if="back") Kembali
          v-icon mdi-arrow-left-circle
        v-btn(class="mx-1" @click="doReset" v-else) Bersihkan
          v-icon mdi-refresh
        v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="billingForm") Proses
          v-icon mdi-arrow-right-circle

</template>
<script>
export default {
  name: 'FBillingForm',
  props: ["back", "billingData", "mapData", "payTypeData", "auto","content"],
  data() {
    return {
      billing: {
        useNpwp: true,
        npwp: "",
        mapTransaction: "",
        jenisSetor: "",
        nama: "",
        alamat: "",
        kota: "",
        periode1: "",
        periode2: "",
        tahun: "",
        noKetetapan: "",
        npwpSetor: "",
        idWajibPajak: "",
        nop: "",
        kpp: "",
        billNumber: "",
        expiredDate: "",
        amount: 0,
        additionalData: {
          map: null,
          payType: null
        }
      },
      kdskpd: "",
      map: null,
      payType: null,
      validateNop:false,
      validateSK:false,
    }
  },
  mounted() {
    this.doReset();
  },
  computed: {
    month(){
      return this.$options.filters.month(new Date());
    },
    year(){
      return this.$options.filters.year(new Date());
    },
    requiredNoSK(){
      this.payType = this.payTypeData==null?this.payType:this.payTypeData[0];
      return this.payType==null?true:this.payType.validateNoSk==null?true:this.payType.validateNoSk;
    },
    requiredNop(){
      this.payType = this.payTypeData==null?this.payType:this.payTypeData[0];
      return this.payType==null?true:this.payType.validateNop==null?true:this.payType.validateNop;
    },
    requiredIdPeserta(){
      this.payType = this.payTypeData==null?this.payType:this.payTypeData[0];
      return this.payType==null?true:this.payType.validateIdPeserta==null?true:this.payType.validateIdPeserta;
    },
    requiredNpwp(){
      this.payType = this.payTypeData==null?this.payType:this.payTypeData[0];
      return this.payType==null?true:this.payType.validateNpwp==null?true:this.payType.validateNpwp;
    },
    requiredNoFaktur(){
      this.payType = this.payTypeData==null?this.payType:this.payTypeData[0];
      return this.payType==null?true:this.payType.validateNoFaktur==null?true:this.payType.validateNoFaktur;
    },
    requiredNpwpRekanan(){
      this.payType = this.payTypeData==null?this.payType:this.payTypeData[0];
      return this.payType==null?true:this.payType.validateNpwpRekanan==null?true:this.payType.validateNpwpRekanan;
    },
    requiredNikRekanan(){
      this.payType = this.payTypeData==null?this.payType:this.payTypeData[0];
      return this.payType==null?true:this.payType.validateNikRekanan==null?true:this.payType.validateNikRekanan;
    },
    uraian(){
      return (this.billing.npwpRekanan==null?"-":this.billing.npwpRekanan) + ";" +
          (this.billing.nikRekanan==null?"-":this.billing.nikRekanan) + ";" +
          (this.billing.noFaktur==null?"-":this.billing.noFaktur) + ";" +
          (this.billing.kodePemda==null?"-":this.billing.kodePemda) +
          (this.billing.kdSkpd==null?"-":this.billing.kdSkpd) + ";" +
          (this.content==null||this.content.productCode=="SP2D"||this.content.productCode=="KASDA_SP2D"||this.content.info.jenisDokumen=="SP2D"?
              (this.billing.noSpm==null?"-":this.billing.noSpm):(this.content&&this.content.productCode=="KASDA_SPJ"||this.content.info.jenisDokumen=="SPJ"?
                  (this.content.info.noDokumen==null?"-":this.content.info.noDokumen):(this.content.info.noBukti==null?"-":this.content.info.noBukti)));
    }
  },
  watch: {
    billingData(val) {
      this.billing = val ? val : {
        useNpwp: true,
        npwp: "",
        mapTransaction: "",
        jenisSetor: "",
        nama: "",
        alamat: "",
        kota: "",
        periode1: this.month,
        periode2: this.month,
        tahun: this.year,
        noKetetapan: "",
        npwpSetor: "",
        idWajibPajak: "",
        nop: "",
        kpp: "",
        billNumber: "",
        expiredDate: "",
        amount: 0,
        additionalData: {
          map: null,
          payType: null
        }
      };

      this.kdskpd=this.billing.kdSkpd;
      if (this.$refs.billingForm) {
        this.$refs.billingForm.resetValidation();
      }
      if (this.auto) {
        this.doInquiryNpwp();
      }
    }
  },
  methods: {
    doReset(){
      this.billing = {
        useNpwp: true,
        npwp: "",
        mapTransaction: "",
        jenisSetor: "",
        nama: "",
        alamat: "",
        kota: "",
        periode1: this.month,
        periode2: this.month,
        tahun: this.year,
        noKetetapan: "",
        npwpSetor: "",
        idWajibPajak: "",
        nop: "",
        kpp: "",
        billNumber: "",
        expiredDate: "",
        amount: 0,
        additionalData: {
          map: null,
          payType: null
        }
      };
      this.map = null;
      this.payType = null;
      if (this.$refs.billingForm) {
        this.$refs.billingForm.resetValidation();
      }
      
    },
    doInquiryNpwp(){
      if (!this.billing.mapTransaction) {
        this.$message.error("Harap pilih kode map terlebih dahulu");
      } else if (!this.billing.jenisSetor) {
        this.$message.error("Harap pilih jenis setoran terlebih dahulu");
      } else if (!this.billing.npwp) {
        this.$message.error("Harap input npwp terlebih dahulu");
      } else {
        this.$progress.show(true);
        this.$http.post("api/transaction/inquiry-npwp", this.billing)
            .then(success => {
              this.billing = success.data;
            }, err => {
              this.$message.error(err.response.data.message);
            }).finally(() => this.$progress.show(false));
      }
    },
    doCreateBilling(){
      if (this.$refs.billingForm.validate()) {
        if (!this.billing.useNpwp) {
          this.billing.npwp = "000000000" + this.billing.kpp + "000";
        }
        this.billing.additionalData.map = this.map;
        this.billing.additionalData.payType = this.payType;
        // this.billing.namaJenisSetor = this.payType==null?this.billing.additionalData.payType.description:this.payType.description
        this.billing.uraian=((this.billing.npwpRekanan==null||this.billing.npwpRekanan==""?"-":this.billing.npwpRekanan) + ";" +
            (this.billing.nikRekanan==null||this.billing.nikRekanan==""?"-":this.billing.nikRekanan) + ";" +
            (this.billing.noFaktur==null||this.billing.noFaktur==""?"-":this.billing.noFaktur) + ";" +
            (this.billing.kodePemda==null||this.billing.kodePemda==""?"-":this.billing.kodePemda) +
            (this.billing.kdSkpd==null||this.billing.kdSkpd==""?"-":this.billing.kdSkpd) + ";" +
            (this.content.productCode.includes("SP2D")?(this.billing.noSpm==null||this.billing.noSpm==""?"-":this.billing.noSpm)
                :(this.content.info.noBukti==null||this.billing.noBukti==""?"-":this.content.info.noBukti)));
        this.billing.noTransaksi= this.content.info.noTransaksi;
        this.$progress.show(true);
        this.$http.post("api/transaction/billing", this.billing)
            .then(success => {
              this.billing = success.data;
              this.$emit("billing", this.billing);
            }, err => {
              this.$message.error(err.response.data.message);
            }).finally(() => this.$progress.show(false));
      }
    },
    eventEmit(event){
      this.$emit(event)
    },
  },
}
</script>